import { createAsyncThunk } from '@reduxjs/toolkit';
import { AuthService } from '../../epics/auth';
import {
    forgotPasswordKey,
    getAccountByIdKey,
    loginKey,
    logoutKey,
    newPasswordKey,
    newPhoneKey,
    signupKey,
} from '../account/accountKeys';

export const login = createAsyncThunk(
    loginKey,
    async (credentials, thunkApi) => {
        try {
            const response = await AuthService.login(credentials);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const signUp = createAsyncThunk(
    signupKey,
    async (credentials, thunkApi) => {
        try {
            const response = await AuthService.signUp(credentials);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const logout = createAsyncThunk(
    logoutKey,
    async (accountId, thunkApi) => {
        try {
            const response = await AuthService.logout(accountId);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const getAccountById = createAsyncThunk(
    getAccountByIdKey,
    async (accountId, thunkApi) => {
        try {
            const response = await AuthService.getAccountById(accountId);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const forgotPassword = createAsyncThunk(
    forgotPasswordKey,
    async (email, thunkApi) => {
        try {
            const response = await AuthService.forgotPassword(email);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const newPassword = createAsyncThunk(
    newPasswordKey,
    async (values, thunkApi) => {
        try {
            const response = await AuthService.newPassword(values);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(error.message);
        }
    },
);

export const newPhone = createAsyncThunk(
    newPhoneKey,
    async (values, thunkApi) => {
        try {
            const response = await AuthService.newPhone(values);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);

export const completeGoogleSignup = createAsyncThunk(
    'account/completeGoogle',
    async (values, thunkApi) => {
        try {
            const response = await AuthService.completeGoogle(values);
            return response;
        } catch (error) {
            return thunkApi.rejectWithValue(
                typeof error === 'string' ? error : error.message,
            );
        }
    },
);
